import React from "react";
import UploadDataComponent from "../bases/UploadDataComponent/UploadDataComponent";
export default function UploadDataPage() {
  return (
    <div className="pp-page">
      <UploadDataComponent />
    </div>
  );
}
